<template>
  <div class="vKeyboard-container" v-if="showOrHide">
    <div class="pickup-tickets-wrapper vkey-wrapper">
      <div class="virtual-keyboard-component">
        <div class="virtual-keyboard-header">
          <div class="virtual-keyboard-title">
            <span>keyboard</span>
            <strong>{{ inputLabel }}</strong>
          </div>
          <div class="virtual-keyboard-preview" v-if="!hideTypingInput">
            {{ inputValue || "Start typing..." }}
          </div>
          <button type="button" @click.prevent.stop="callClose">
            Close
          </button>
        </div>
        <Keyboard
          :input="inputValue"
          @onChange="onChangeInput"
          :inputName="inputName"
          @onKeyPress="onKeyPress"
          :keyBoardType="keyType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SimpleKeyboard from "@/components/UIElements/SimpleKeyboard";
// import { mapState, mapGetters, mapActions } from "vuex";
import { generateRandomCode } from "@/helper/collection";

export default {
  components: {
    Keyboard: SimpleKeyboard,
  },
  props: {
    onClickHandler: { type: Function },
    onChangeEvent: { type: Function },
    onKeyEnter: { type: Function },
    showOrHide: { type: Boolean, default: true },
    hideTypingInput: { type: Boolean, default: false },
    inputName: { type: String },
    initialValue: { type: String, default: "" },
    keyBoardType: { type: String, default: "Default" },
  },
  data() {
    return {
      ShowVirtualKeyBoard: false,
      InputString: "",
      selectedEle: null,
    };
  },
  computed: {
    keyType() {
      return this.keyBoardType;
    },
    inputValue() {
      return this.initialValue || '';
    },
    inputLabel() {
      const value = String(this.inputName || "").toLowerCase();
      if (value.includes("password")) return "Password field";
      if (value.includes("username")) return "Username field";
      return "Active field";
    },
  },
  beforeMount() {},
  methods: {
    generateRandomCode,
    onKeyPress(button) {
      if (button == "{enter}") {
        this.$emit("onKeyEnter", button);
      }
      if (button == "{close}") {
        this.$emit("onClickClose");
      }
      this.$emit("onPressKey", button);
    },
    onChangeInput(event) {
      this.InputString = event;
      this.$emit("changeKeyboardInput", this.InputString);
      this.$emit("onChangeEvent", this.InputString);
    },
    callClose: function () {
      this.$emit("onClickClose");
    },
  },
};
</script>
<style>
.vKeyboard-container {
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  max-width: 100vw !important;
  height: auto !important;
  position: fixed !important;
  z-index: 2400 !important;
  padding: 0 18px 16px;
  margin: 0 !important;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0), rgba(15, 23, 42, 0.1));
  transform: none !important;
}

.virtual-keyboard-component {
  width: 100%;
  max-width: 1120px;
  height: auto;
  margin: auto;
  padding: 12px 14px 14px;
  border: 1px solid rgba(203, 213, 225, 0.86);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -18px 50px rgba(15, 23, 42, 0.16);
}

.virtual-keyboard-header {
  min-height: 36px;
  padding: 0 4px 8px;
  display: grid;
  align-items: center;
  grid-template-columns: 130px minmax(0, 1fr) 82px;
  column-gap: 10px;
}

.virtual-keyboard-title {
  min-width: 0;
}

.virtual-keyboard-title span {
  display: block;
  color: #111827;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.virtual-keyboard-title strong {
  display: block;
  margin-top: 3px;
  color: #7b8492;
  font-size: 11px;
  font-weight: 650;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.virtual-keyboard-preview {
  min-width: 0;
  width: 100%;
  padding: 0 10px;
  color: #111827;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  border: 0;
  opacity: 0.86;
}

.virtual-keyboard-header button {
  height: 32px;
  width: 82px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 750;
  background: var(--blue);
  cursor: pointer;
}

.closeBtnKeyboard {
  width: 45px;
  border: none;
  height: 35px;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 0;
  font-size: 50px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  background-color: transparent;
  top: 4px !important;
  right: 4px !important;
  color: #6d6767;
  justify-content: center;
}

.vkey-wrapper {
  width: 100vw !important;
  max-width: 100vw !important;
  height: auto !important;
  margin: 0 !important;
  border-radius: 22px 22px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent !important;
}

@media (max-width: 900px), (max-height: 720px) {
  .vKeyboard-container {
    padding: 0 10px 10px;
  }

  .virtual-keyboard-component {
    padding: 10px;
    border-radius: 18px;
  }

  .virtual-keyboard-header {
    min-height: 32px;
    padding-bottom: 6px;
    grid-template-columns: 108px minmax(0, 1fr) 72px;
    column-gap: 6px;
  }

  .virtual-keyboard-preview {
    font-size: 12px;
  }
}

@media (max-height: 640px) {
  .virtual-keyboard-header {
    min-height: 30px;
    padding-bottom: 5px;
  }

  .virtual-keyboard-title span {
    font-size: 12px;
  }

  .virtual-keyboard-title strong {
    display: none;
  }
}

@media (max-width: 640px) {
  .virtual-keyboard-header {
    grid-template-columns: 92px minmax(0, 1fr) 66px;
  }

  .virtual-keyboard-preview {
    grid-column: auto;
    grid-row: auto;
    padding: 0 6px;
    font-size: 11px;
  }

  .virtual-keyboard-header button {
    width: 66px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Vkeyboard.vue